import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Slider from "../../../components/List/SliderList.jsx";

const AdminSlider = () => {
    return (
        <div className="dashboard">
            <Sidebar />
            <div className="dashboardContainer">
                <Navbar />
                <div className="listContainer">
                    <Slider title={"Slider"} />
                </div>
            </div>
        </div>
    )
}

export default AdminSlider
